module.exports = __webpack_public_path__ + "img/优秀.418c13fc.png";